'use client';

import { Sheet, SheetTrigger, SheetContent } from '@eliadmin/core/src/components/ui/sheet';
import { getUnavailablePreviewLabel } from '@eliadmin/core/src/components/configurator/configurator-preview-copy';
import { ProformConfiguratorPreview } from '@eliadmin/core/src/components/configurator/proform-configurator-preview';
import { getProformPreviewModelForConfiguration } from '@eliadmin/core/src/components/configurator/proform-preview-assets';
import { useProformPreviewAvailability } from '@eliadmin/core/src/components/configurator/use-proform-preview-availability';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import {
  useConfiguratorStore,
  useProformQuery,
} from '@eliadmin/core/src/stores/configurator-store';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { getProformPreviewUrl } from '@eliadmin/core/src/utils/proform-utils';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import { RiSearchEyeLine } from 'react-icons/ri';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';
import { useState } from 'react';

export function ConfiguratorMobilePreview() {
  const user_konf_id = useConfiguratorStore(s => s.user_konf_id);
  const productDetail = useConfiguratorStore(s => s.productDetail);
  const productCode = useConfiguratorStore(s => s.cislo_nomenklatury);
  const productConf = useConfiguratorStore(s => s.productConf);
  const { data: productConfId } = useProformQuery('GET_PRODUCT_CONF_ID', {
    user_konf_id,
  });
  const { t } = useTranslations();
  const locale = useLocaleStore(s => s.currentLocale);

  const imgPreviewUrl = getProformPreviewUrl(productConfId, productDetail);
  const previewModel = getProformPreviewModelForConfiguration(
    productCode,
    productConfId,
    productConf,
  );
  const previewAvailability = useProformPreviewAvailability(previewModel);
  const hasInteractivePreview = previewAvailability === 'available';
  const hasModelPreviewConvention = Boolean(previewModel);
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="col-span-1 flex items-center justify-center">
      <Sheet open={isOpen} onOpenChange={setIsOpen}>
        <SheetTrigger>
          <div
            className="
              flex
              w-full items-center justify-center
              gap-2.5
              text-base
              font-medium
              text-accent
          "
          >
            <RiSearchEyeLine size={20} /> {t('text1469')}
          </div>
        </SheetTrigger>
        <SheetContent side={'bottom'} className="h-[95vh] overflow-y-auto">
          {hasInteractivePreview && isOpen ? (
            <ProformConfiguratorPreview
              className="min-h-full"
              productConfId={productConfId}
              productDetail={productDetail}
            />
          ) : hasModelPreviewConvention && previewAvailability === 'checking' ? (
            <div
              className="flex h-full w-full items-center justify-center rounded-xl bg-muted px-6 text-center text-sm font-semibold text-muted-foreground"
              role="status"
            >
              Ověřuji dostupnost náhledu…
            </div>
          ) : hasModelPreviewConvention && previewAvailability === 'unavailable' ? (
            <div
              className="flex h-full w-full items-center justify-center rounded-xl border border-border bg-muted px-6 text-center"
              role="status"
            >
              <p className="text-3xl font-semibold text-destructive">
                {getUnavailablePreviewLabel(locale)}
              </p>
            </div>
          ) : (
            <div
              className={cn(
                'relative flex h-full w-full items-center justify-center text-center',
                !imgPreviewUrl && 'bg-[#FFEBEB]',
              )}
            >
              {imgPreviewUrl ? (
                <Image
                  src={imgPreviewUrl}
                  alt={t('text1452')}
                  width={0}
                  height={0}
                  sizes="100vw"
                  className="h-full w-full object-contain"
                />
              ) : (
                <HtmlRendererRaw
                  as="h4"
                  className="text-3xl font-semibold text-destructive"
                  html={t('text1452').replace(/ /g, '<br/>')}
                />
              )}
            </div>
          )}
        </SheetContent>
      </Sheet>
    </div>
  );
}
